import { render, staticRenderFns } from "./masterList.vue?vue&type=template&id=0cc208fa&scoped=true&lang=html"
import script from "./masterList.vue?vue&type=script&lang=js"
export * from "./masterList.vue?vue&type=script&lang=js"
import style0 from "./masterList.vue?vue&type=style&index=0&id=0cc208fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc208fa",
  null
  
)

export default component.exports